import type { ReactNode } from 'react';
import { type RegisterOptions, useFormContext } from 'react-hook-form';

import { Input, type InputProps } from '../input/input.component';
import { FormField } from './form-field.component';
import { useFieldError } from './use-field-error';

export interface TextFieldProps extends Omit<InputProps, 'name' | 'required'> {
	name: string;
	label?: ReactNode;
	description?: ReactNode;
	tooltip?: ReactNode;
	required?: boolean;
	rules?: RegisterOptions;
}

/** RHF-bound text input: label + validation + tooltip, wired via `useFormContext`. */
export function TextField({
	name,
	label,
	description,
	tooltip,
	required,
	rules,
	...inputProps
}: TextFieldProps) {
	const { register } = useFormContext();
	const { invalid, message } = useFieldError(name);

	return (
		<FormField
			name={name}
			label={label}
			description={description}
			tooltip={tooltip}
			required={required}
			error={message}
		>
			<Input id={name} invalid={invalid} {...inputProps} {...register(name, rules)} />
		</FormField>
	);
}
